/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useContext } from "react";
import { showToast } from "utils/helper";
import Layout from "components/layout";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardTitle,
  Combobox,
  DatePicker,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea,
} from "@repo/ui";
import {
  useAutocompleteInterBranchCIT,
  useAutocompleteHolding,
  useGetCashCenters,
  useGetRoutes,
} from "utils/apis/lookups.api";
import { zodResolver } from "@hookform/resolvers/zod";
import type { UseFormReturn } from "react-hook-form";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { PREV_5_DAY_DATE } from "utils/constant";
import { useCreateInterBranchOrder } from "utils/apis/inter-branch.api";
import SearchableDropdown from "components/searchableDropdown";
import { format } from "date-fns";
import { UserContext } from "utils/reducers/user";

const formSchema = z.object({
  jobType: z.string().min(1, { message: "Job Type is required." }),
  onwardCashCenterId: z
    .string()
    .min(1, { message: "Onward Cash Center is required." }),
  sourceCustomer: z.string().optional(),
  sourceCustomerName: z.string().optional(),
  sourceSPId: z.string().min(1, { message: "Source location is required." }),
  onwardSPId: z.string().optional(),
  serviceDateTime: z.date({ required_error: "Service date is required." }),
  invoicingModel: z
    .string()
    .min(1, { message: "Invoicing Model is required." }),
  priority: z.string().min(1, { message: "Job Priority is required." }),
  shift: z.string().min(1, { message: "Shift is required." }),
  jobNature: z.string(),
  requestedBy: z.string().min(1, { message: "Requested By is required." }),
  routeNo: z.string().optional(),
  remarks: z.string().optional(),
});

const jobPriorities = [
  { value: "1", name: "Critical" },
  { value: "2", name: "High" },
  { value: "3", name: "Normal" },
  { value: "4", name: "Low" },
];

const jobNatures = [
  { value: "Normal", name: "Normal" },
  { value: "Adhoc", name: "Adhoc" },
  { value: "Special Service", name: "Special Service" },
];

const invoicingModels = [
  { value: "Fixed", name: "Fixed" },
  { value: "Dedicated", name: "Dedicated" },
  { value: "Service", name: "Service" },
];

const jobTypes = [
  // { value: "Collection", name: "Collection" },
  // { value: "Holding", name: "Holding" },
  { value: "Delivery", name: "Delivery" },
];

export default function CreateInterBranch() {
  const user = useContext(UserContext);

  // display objects for request-review
  const [sourceLocation, setSourceLocation] = useState<any>(null);
  const [destinationLocation, setDestinationLocation] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [onwardSearch, setOnwardSearch] = useState("");
  const [customerId, setCustomerId] = useState("");

  // react-hook-form
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      jobType: "Delivery",
      onwardCashCenterId: "",
      requestedBy: "",
      sourceCustomer: "",
      sourceCustomerName: "",
      sourceSPId: "",
      onwardSPId: "",
      invoicingModel: "Service",
      serviceDateTime: new Date(),
      priority: "3",
      jobNature: "Normal",
      shift: "morning",
      routeNo: "",
      remarks: "",
    },
  });

  // lookups/hooks
  const { data: inRouteTeams } = useGetRoutes();
  const { data: cashCenters } = useGetCashCenters();
  // master site list (contains barcode and fallback details)
  const { data: sourceLocations, isFetching: isFetchingAutocomplete } =
    useAutocompleteInterBranchCIT(searchTerm, user?.CashCenterId);

  const {
    mutate: createInterBranchOrder,
    isSuccess: isOrderSuccess,
    isPending: isOrderPending,
    isError: isOrderError,
    reset: orderReset,
  } = useCreateInterBranchOrder();

  const isHolding = form.watch("jobType") === "Holding";
  const onwardCashCenterId = form.watch("onwardCashCenterId");

  const { data: onwardLocations, isFetching: isFetchingOnward } =
    useAutocompleteInterBranchCIT(
      isHolding ? "" : onwardSearch,
      onwardCashCenterId,
    );
  const { data: holdingList, isFetching: isFetchingHolding } =
    useAutocompleteHolding(isHolding ? onwardSearch : "");

  // Source location selection
  const onSourceLocationChanged = (value: string) => {
    // block same as destination
    const destSpId = destinationLocation?.servicePointId;
    if (destSpId && String(destSpId) === String(value)) {
      showToast(
        "error",
        "Source and destination locations cannot be the same.",
      );
      form.setValue("sourceSPId", "");
      form.setValue("sourceCustomer", "");
      form.setValue("sourceCustomerName", "");
      setSourceLocation(null);
      return;
    }

    const selectedSP = sourceLocations?.find(
      (item: any) => item?.servicePointId === value,
    );
    if (selectedSP) {
      setSourceLocation(selectedSP);
      setCustomerId(selectedSP?.customerId);

      form.setValue("sourceCustomer", selectedSP?.customerId);
      form.setValue("sourceCustomerName", selectedSP?.customer);
    }
  };

  const onDestinationLocationChanged = (value: string) => {
    const sourceSpId =
      sourceLocation?.servicePointId || form.getValues("sourceSPId");
    if (sourceSpId && String(sourceSpId) === String(value)) {
      showToast(
        "error",
        "Source and destination locations cannot be the same.",
      );
      form.setValue("onwardSPId", "");
      setDestinationLocation(null);
      setCustomerId("");

      return;
    }

    const selectedSP = (isHolding ? holdingList : onwardLocations)?.find(
      (item: any) => item?.servicePointId === value,
    );

    if (selectedSP) {
      setDestinationLocation(selectedSP);
    }
  };

  const addJob = (values: z.infer<typeof formSchema>) => {
    const currentDate = new Date();
    // build a Date object combining selected serviceDate and current time
    const svcDate = new Date(values.serviceDateTime);
    svcDate.setHours(
      currentDate.getHours(),
      currentDate.getMinutes(),
      currentDate.getSeconds(),
      currentDate.getMilliseconds(),
    );

    const job: any = {
      ...values,
      customerId,
      priority: Number(values.priority || "0"),
      serviceDateTime: format(
        values.serviceDateTime,
        "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
      ),
    };

    delete job.sourceCustomerName;
    delete job.sourceCustomer;

    createInterBranchOrder(job);
  };

  const onJobTypeChange = () => {
    form.setValue("onwardSPId", "");
    setDestinationLocation(null);
    setOnwardSearch("");
  };

  // result handling
  useEffect(() => {
    if (isOrderSuccess) {
      form.reset();
      orderReset();
      setDestinationLocation(null);
      setSourceLocation(null);
      setCustomerId("");
      setSearchTerm("");
      setOnwardSearch("");
    }
    if (isOrderError) {
      orderReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOrderSuccess, isOrderError]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <Link to="/inter-branch-services">Inter Branch</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Create Inter Branch Request</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <div className="flex mx-4 my-5 gap-3">
        <Card className="flex-1">
          <CardContent className="p-4">
            <Form {...form}>
              <form
                id="collection-form"
                onSubmit={form.handleSubmit(addJob)}
                className="gap-4 grid grid-cols-2"
              >
                <FormSelect
                  form={form}
                  data={invoicingModels}
                  name="invoicingModel"
                  label="Invoicing Model"
                  placeholder="Select Invoicing Model"
                />
                <FormSelect
                  form={form}
                  data={jobTypes}
                  name="jobType"
                  label="Job Type"
                  placeholder="Select Job Type"
                  onChange={onJobTypeChange}
                />

                <FormField
                  control={form.control}
                  name="sourceSPId"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Source Location</FormLabel>

                      <SearchableDropdown
                        placeholder="Search Source Location"
                        value={field.value}
                        searchTerm={searchTerm}
                        onSearchChange={setSearchTerm}
                        data={
                          sourceLocations?.map((item: any) => ({
                            value: item.servicePointId,
                            label: `${item.barcode || ""}-${item.locationId}`,
                          })) || []
                        }
                        loading={isFetchingAutocomplete}
                        onChange={(val) => {
                          field.onChange(val);
                          onSourceLocationChanged(val);
                        }}
                      />

                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="sourceCustomerName"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Source Location Customer</FormLabel>
                      <FormControl>
                        <Input
                          type="text"
                          placeholder="Select Source Location"
                          readOnly
                          {...field}
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormSelect
                  form={form}
                  data={
                    cashCenters?.map((item: any) => ({
                      value: item.cashCenterId,
                      name: `(${item.barcode || ""}) ${item.name}`,
                    })) || []
                  }
                  name="onwardCashCenterId"
                  label="Onward Cash Center"
                  placeholder="Select Cash Center"
                />
                <FormField
                  control={form.control}
                  name="onwardSPId"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Onward Location</FormLabel>

                      <SearchableDropdown
                        placeholder="Search Onward Location"
                        value={field.value}
                        searchTerm={onwardSearch}
                        onSearchChange={setOnwardSearch}
                        data={
                          (isHolding ? holdingList : onwardLocations)?.map(
                            (item: any) => ({
                              value: item.servicePointId,
                              label: `${item.barcode || ""}-${item.locationId}`,
                            }),
                          ) || []
                        }
                        loading={isFetchingOnward || isFetchingHolding}
                        onChange={(val) => {
                          field.onChange(val);
                          onDestinationLocationChanged(val);
                        }}
                      />

                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="serviceDateTime"
                  render={({ field }) => (
                    <FormItem className="space-y-2">
                      <FormLabel>Service Date</FormLabel>
                      <DatePicker
                        {...field}
                        placeholder="Pick a date"
                        selectedDate={field.value}
                        onSelectDate={field.onChange}
                        disabled={(date) => date < PREV_5_DAY_DATE}
                      />
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormSelect
                  form={form}
                  data={jobPriorities}
                  name="priority"
                  label="Job Priority"
                  placeholder="Select Job Priority"
                />
                <FormSelect
                  form={form}
                  data={jobNatures}
                  name="jobNature"
                  label="Job Nature"
                  placeholder="Select Job Nature"
                />

                <FormCombobox
                  form={form}
                  data={inRouteTeams
                    ?.filter((i) => i.routeType === "Dedicated Route")
                    .map((m: any) => ({
                      value: String(m.routeNo),
                      label: `${m.routeNo} (${m.description})`,
                    }))}
                  name="routeNo"
                  label="Route"
                  placeholder="Select Route"
                />

                <FormField
                  control={form.control}
                  name="requestedBy"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Requested By</FormLabel>
                      <FormControl>
                        <Input
                          type="text"
                          placeholder="Select Requested By"
                          {...field}
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="remarks"
                  render={({ field }) => (
                    <FormItem className="col-span-2">
                      <FormLabel>Remarks</FormLabel>
                      <FormControl>
                        <Textarea
                          placeholder="Write your remarks"
                          className="resize-none"
                          {...field}
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </form>
            </Form>
          </CardContent>
        </Card>

        <Card className="flex-1">
          <CardContent className="p-4">
            <CardTitle className="text-lg">Request Review</CardTitle>
            <CardDescription className="mt-4">
              <h5 className="text-md font-bold">Source Location</h5>
              <div className="mt-2 grid grid-cols-3 gap-3">
                <div>
                  <label>Location ID</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {sourceLocation?.locationId || "-"}{" "}
                  </div>
                </div>
                <div>
                  <label>Location Name</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {sourceLocation?.locationName ||
                      sourceLocation?.name ||
                      "-"}{" "}
                  </div>
                </div>
                <div>
                  <label>Location Type</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.locationType ||
                      (sourceLocation?.name ? "Cash Center" : "-")}{" "}
                  </div>
                </div>
                <div>
                  <label>Route No</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {sourceLocation?.routeNo || "-"}
                  </div>
                </div>
                <div>
                  <label>Site Limit</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {sourceLocation?.siteLimit || "-"}
                  </div>
                </div>
                <div>
                  <label>Service Days</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {sourceLocation?.serviceDays || "-"}
                  </div>
                </div>
              </div>

              <hr className="border-b bg-accent my-4" />

              <h5 className="text-md font-bold">Delivery Site</h5>
              <div className="mt-2 grid grid-cols-3 gap-3">
                <div>
                  <label>Location ID</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {destinationLocation?.locationId || "-"}{" "}
                  </div>
                </div>
                <div>
                  <label>Location Name</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {destinationLocation?.locationName ||
                      destinationLocation?.name ||
                      "-"}{" "}
                  </div>
                </div>
                <div>
                  <label>Location Type</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {destinationLocation?.locationType ||
                      (destinationLocation?.name ? "Cash Center" : "-")}{" "}
                  </div>
                </div>
                <div>
                  <label>Route No</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {destinationLocation?.routeNo || "-"}
                  </div>
                </div>
                <div>
                  <label>Site Limit</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {destinationLocation?.siteLimit || "-"}
                  </div>
                </div>
                <div>
                  <label>Service Days</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {" "}
                    {destinationLocation?.serviceDays || "-"}
                  </div>
                </div>
              </div>

              <Button
                type="submit"
                disabled={isOrderPending}
                isLoading={isOrderPending}
                variant="secondary"
                className="w-full mt-5"
                form="collection-form"
              >
                Confirm order
              </Button>
            </CardDescription>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}

/* ---------- Helper components (FormSelect, FormCombobox) ---------- */

function FormSelect({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder?: string;
  data?: { name: string; value: any }[];
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Select
            onValueChange={(e) => {
              field.onChange(e);
              onChange?.(e);
            }}
            value={field.value as any}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {data?.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

function FormCombobox({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
  disabled,
  ...props
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder: string;
  data?: { label: string; value: any }[];
  disabled?: boolean;
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Combobox
            value={field.value as any}
            setValue={(e: string) => {
              field.onChange(e);
              onChange?.(e);
            }}
            data={data}
            placeholder={placeholder}
            disabled={disabled}
            {...props}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
